import React from 'react';
import { TableHead, TableRow, TableCell } from '@mui/material';

/**
 * TableHeader component for consistent table headers
 * Provides the standard header structure for course tables
 */
const TableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell 
          sx={{ 
            fontWeight: 'bold',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
            width: '40%'
          }}
        >
          Course Name
        </TableCell>
        <TableCell 
          sx={{ 
            fontWeight: 'bold',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
            width: '15%'
          }}
        >
          Course Code
        </TableCell>
        <TableCell 
          sx={{ 
            fontWeight: 'bold',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
            width: '10%'
          }}
        >
          Credits
        </TableCell>
        <TableCell 
          sx={{ 
            fontWeight: 'bold',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
            borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
            width: '35%'
          }}
        >
          Notes
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader; 